'use client'

import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { handleCMS } from "@/(front-desk)/store"
import { categoryList } from "./page"
import { Pattern1 } from "@/(front-desk)/utils/patterns"
import { ArrowDownIcon } from "@heroicons/react/24/solid"
import { reportError } from "@/(front-desk)/utils/functions"
import Marquee from "@/(front-desk)/components/Marquee"
import Link from "next/link"
import classNames from "classnames"
import axios from "axios"
import dayjs from "dayjs"
import AOS from 'aos'
import 'aos/dist/aos.css'
import newsPlaceholder from "@/(front-desk)/assets/images/news-placeholder.png"


const pageSize = 6
export default function News(props) {

    const category = props.category
    const dispatch = useDispatch()
    const CMS = useSelector((state) => state.CMS)
    const [ newsList, setNewsList ] = useState([])
    const [ displayNum, setDisplayNum ] = useState(6)
    const [ newsCount, setNewsCount ] = useState(0)

    const categoryInfo = {
        all: {
            url: '/api/v1/cms/zh_hant/posts?category=cms.news.blogs',
            data: CMS.newsAll,
            func: 'setNewsAll'
        },
        announcement: {
            url: '/api/v1/cms/zh_hant/posts?category=cms.news.blogs.announcements',
            data: CMS.newsAnnouncement,
            func: 'setNewsAnnouncement'
        },
        media: {
            url: '/api/v1/cms/zh_hant/posts?category=cms.news.blogs.media_reports',
            data: CMS.newsMedia,
            func: 'setNewsMedia'
        },
        column: {
            url: '/api/v1/cms/zh_hant/posts?category=cms.news.blogs.columns',
            data: CMS.newsColumn,
            func: 'setNewsColumn'
        },
        lecture: {
            url: '/api/v1/cms/zh_hant/posts?category=cms.news.blogs.lecture_series',
            data: CMS.newsLecture,
            func: 'setNewsLecture'
        },
        activity: {
            url: '/api/v1/cms/zh_hant/posts?category=cms.news.blogs.bts',
            data: CMS.newsActivity,
            func: 'setNewsActivity'
        }
    }

    useEffect(() => {
        if (!CMS.newsDataFetch) {
            for (const type in categoryInfo) {
                getNewsList(type)
            }
        }
    }, [])

    useEffect(() => {
        handleDataFetchEnd()
    }, [CMS])

    useEffect(() => {
        if (categoryInfo[category].data) {
            setNewsList(categoryInfo[category].data.results)
            setNewsCount(categoryInfo[category].data.count)
        }
    }, [categoryInfo[category].data])

    useEffect(() => {
        AOS.init()

        // if request newsList's length > page size
        if (newsList.length >= pageSize) {
            getNewsList(category)
        }
    }, [displayNum])

    function getNewsList(type) {
        const page = Math.floor(newsList.length / pageSize) + 1
        axios.get(`${categoryInfo[type].url}&page_size=${pageSize}&page=${page}`)
        .then((res) => {
            if (CMS.newsDataFetch) {
                // console.log('news list success: ', res.data.body)
                setNewsCount(res.data.body.count)
                for (const item of res.data.body.results) {
                    setNewsList(newsList => [ ...newsList, item])
                }
            }
            else {
                // console.log(type, res.data.body)
                dispatch(handleCMS.actions[categoryInfo[type].func](res.data.body))
            }
        })
        .catch((err) => {
            // console.log(err.config?.url, err)
            reportError(err, true)
            
        })
    }
    
    function handleDataFetchEnd() {
        const categoryList = Object.keys(categoryInfo)
        let count = 0
        categoryList.map((e) => {
            if (categoryInfo[e].data) {
                count += 1
            }
        })
        if (count === categoryList.length) {
            dispatch(handleCMS.actions.setNewsDataFetch(true))
        }
    }

    return (
        <>
        <title>最新消息 - 放視大賞</title>
        <main className={classNames('news', {
            'loading': !CMS.newsDataFetch
        })}>
            <div className="page-banner">
                <div className="page-banner-content flex justify-between items-center">
                    <div>
                        <h1 className="title">News</h1>
                        <h2 className="sub-title">最新消息</h2>
                    </div>
                    <Pattern1 className="fill-main w-[4.5rem]" />
                </div>
            </div>
            <div id="main" className="news-content py-6 sm:py-12">
                <div className="category-group">
                    <div className="scroll">
                        { Object.keys(categoryList).map((e) => {
                            const itemClass = classNames('btn', {
                                'active': category === e,
                                'hidden': categoryInfo[e].data && categoryInfo[e].data.results.length === 0
                            })
                            const item = 
                                <Link key={`category-${e}`} className={itemClass} href={`/news/${e}`}>
                                    {categoryList[e]}
                                </Link>
                            return item
                        })}
                    </div>
                </div>
                <div className="item-group">
                    { newsList.length === 0 &&
                        <div
                            className="py-12 w-full min-h-[50vh] text-black-500 text-center"
                            data-aos="fade-up"
                        >
                            此分類目前尚無資料
                        </div>
                    }
                    { newsList.map((e, index) => {
                        const itemClass = classNames('item', {
                            'hidden': index >= displayNum
                        })
                        const item = 
                            <Link
                                key={`item-${index}`}
                                data-aos="fade-up"
                                className={itemClass}
                                href={`/news/${category}/article?id=${e.id}`}
                            >
                                <div className="thumbnail">
                                    <img src={e.contents.hero_image?.file || newsPlaceholder.src} alt="" />
                                </div>
                                <div className="title">{e.contents.subject}</div>
                                { e.display_start_time &&
                                    <div className="time">{dayjs(e.display_start_time).format('YYYY.MM.DD')}</div>
                                }
                            </Link>
                        return item
                    })}
                </div>
                { newsList.length < newsCount &&
                    <button className="btn-white btn-round" onClick={() => {setDisplayNum(displayNum + 6)}}>
                        載入更多消息
                        <ArrowDownIcon />
                    </button>
                }
            </div>
            <Marquee />
        </main>
        </>
    )
}
